import React from 'react';
import {
  CaptionedPhoto,
} from '../common';
import './Testimonial.scss';

const Testimonial = (props) => {
  const {
    name,
    photo,
    testimony,
    frameColour,
    index,
    isActive,
    setActiveIndex,
  } = props;
  return (
    <button
      className={`testimonial${isActive ? ' active' : ''}`}
      type="button"
      onClick={() => setActiveIndex(index)}
      aria-label="Focus on this image"
    >
      <CaptionedPhoto
        photo={photo}
        photoCaption={testimony.text}
        alwaysShowCaption
        isSquare={!isActive}
        isPortrait={isActive}
        frameColour={frameColour}
        hasFrame
      />
      <span className="author">
        {name.text}
      </span>
    </button>
  );
};

export default Testimonial;
